import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { CertRequirementDetail, Culture, PortalType } from '@ats/api/cm';
import { LOC_INJECTOR, LocalizationProvider } from '@cm/core/localization';
import { SettingsService } from '@cm/core/settings';
import { Apollo, gql } from 'apollo-angular';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CmCreqUploadService } from '../creq-upload.service';
import {
	CPUploadConfirmationLocKeys,
	cpUploadConfirmationLocs,
	SPUploadConfirmationLocKeys,
	spUploadConfirmationLocs,
} from './upload-confirmation.locs';

const CREQ_CULTURES = gql`
	query creqCultures($request: CulturesRequest) {
		cultures(request: $request) {
			id
			name
			label
		}
	}
`;

@Component({
    selector: 'cm-upload-confirmation',
    templateUrl: './upload-confirmation.component.html',
    styleUrls: ['./upload-confirmation.component.scss'],
    providers: [LocalizationProvider({ ...cpUploadConfirmationLocs, ...spUploadConfirmationLocs })],
    standalone: false
})
export class CmUploadConfirmationComponent implements OnInit {
	@Output() restart = new EventEmitter<void>();
	creq$: Observable<Partial<CertRequirementDetail> & { langName: string }>;
	readonly isSP: boolean;

	constructor(
		private uploadService: CmCreqUploadService,
		private settings: SettingsService,
		private apollo: Apollo,
		@Inject(LOC_INJECTOR)
		public readonly locs: CPUploadConfirmationLocKeys & SPUploadConfirmationLocKeys
	) {
		this.isSP = this.settings.portal === PortalType.SponsorPortal;
	}

	ngOnInit() {
		this.creq$ = combineLatest([
			this.fetchCreqCultures$(),
			this.uploadService.creqUpload$,
		]).pipe(
			map(([cultures, creq]) => ({
				...creq,
				langName: cultures.find(culture => culture.name === creq.docLanguage)?.label,
			}))
		);
	}

	startOver() {
		this.restart.emit();
	}

	private fetchCreqCultures$() {
		return this.apollo
			.watchQuery<{ cultures: Partial<Culture>[] }>({
				query: CREQ_CULTURES,
				variables: { request: { onlyNeutral: true } },
			})
			.valueChanges.pipe(map(results => results?.data?.cultures));
	}
}
